import React from 'react';
import { Chip } from '@mui/material';
import { EnvType } from '../Customer/Model/CustomerModel';

/* -------------------- Deployment Status -------------------- */

interface DeploymentStyle {
  label: string;
  color: string;
  bg: string;
}

const deploymentStyles: Record<number, DeploymentStyle> = {
  2: { label: 'Deployed', color: '#2E7D32', bg: '#E8F5E9' },
  1: { label: 'Not Deployed', color: '#ED6C02', bg: '#FFF3E0' },
};

export function getDeploymentStatusChip(
  deploymentStatusId: number,
): React.ReactElement {
  const config = deploymentStyles[deploymentStatusId];

  if (!config) {
    return (
      <Chip
        label="Unknown"
        size="small"
        sx={{
          borderRadius: '999px',
          fontWeight: 600,
          px: 1.5,
          color: '#757575',
          borderColor: '#757575',
          backgroundColor: 'action.hover',
          borderWidth: 1,
          borderStyle: 'solid',
        }}
      />
    );
  }

  return (
    <Chip
      label={config.label}
      size="small"
      variant="outlined"
      sx={{
        borderRadius: '999px',
        fontWeight: 600,
        px: 1.5,
        color: config.color,
        borderColor: config.color,
        backgroundColor: config.bg,
      }}
    />
  );
}

/* -------------------- Environment Chip -------------------- */

interface EnvStyle {
  color: string;
  borderColor: string;
  backgroundColor: string;
}

const envStyles: Record<string, EnvStyle> = {
  Dev: { color: '#2F80ED', borderColor: '#2F80ED', backgroundColor: '#EAF3FF' },
  QA: { color: '#e207b2', borderColor: '#e207bd', backgroundColor: '#e7d4e6' },
  Prod: {
    color: '#2E7D32',
    borderColor: '#2E7D32',
    backgroundColor: '#E8F5E9',
  },
};

export function getEnvChip(env: number): React.ReactElement {
  const label = EnvType[env];
  const style = envStyles[label];

  return (
    <Chip
      label={label}
      variant="outlined"
      size="small"
      sx={{
        borderRadius: '20px',
        fontWeight: 500,
        px: 1.5,
        ...style,
      }}
    />
  );
}
